var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.phone_see)?_c('Login_phone'):_vm._e(),(_vm.sms)?_c('Login_sms'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }